import { useState, useEffect, useRef } from 'react';
import { HelpIcon } from './HelpIcon';
import { Search } from 'lucide-react';

export function LookupField({ id, label, value, onChange, error, helpText, placeholder, required, readOnly, options = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);

  const filtered = options.filter(o =>
    o.label.toLowerCase().includes(search.toLowerCase()) ||
    o.value.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedLabel = options.find(o => o.value === value)?.label || value;

  return (
    <div className="fw" ref={containerRef}>
      <label className="fl" htmlFor={`field-${id}`}>
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <div className="fi-wrap" style={{ position:'relative' }}>
        <input id={`field-${id}`} type="text" value={selectedLabel} readOnly
          onClick={() => !readOnly && setIsOpen(!isOpen)}
          placeholder={placeholder || 'Search...'}
          className={`field-input ${error ? 'field-error-border' : ''} ${readOnly ? 'field-readonly' : ''}`}
          style={{ cursor:readOnly ? 'default' : 'pointer', paddingRight:'2.5rem' }} />
        <div style={{ position:'absolute', right:'0.75rem', top:'50%', transform:'translateY(-50%)', color:'#64748b', pointerEvents:'none' }}>
          <Search size={16} />
        </div>
        {isOpen && !readOnly && (
          <div style={{ position:'absolute', top:'100%', left:0, right:0, zIndex:100, background:'white', border:'1px solid #e2e8f0', borderRadius:'6px', marginTop:'4px', boxShadow:'0 4px 6px -1px rgb(0 0 0 / 0.1)', maxHeight:'300px', display:'flex', flexDirection:'column' }}>
            <div style={{ padding:'8px', borderBottom:'1px solid #f1f5f9' }}>
              <input autoFocus className="field-input" style={{ height:'32px', fontSize:'0.875rem' }}
                placeholder="Filter options..." value={search} onChange={e => setSearch(e.target.value)} />
            </div>
            <div style={{ overflowY:'auto', flex:1 }}>
              {filtered.length > 0 ? filtered.map(o => (
                <div key={o.value} onClick={() => { onChange(o.value); setIsOpen(false); setSearch(''); }}
                  style={{ padding:'8px 12px', cursor:'pointer', fontSize:'0.875rem', background:value === o.value ? '#f0f9ff' : 'transparent', borderLeft:value === o.value ? '3px solid #0ea5e9' : '3px solid transparent' }}
                  onMouseEnter={e => { if (!e.currentTarget) return; e.currentTarget.style.background = '#f8fafc'; }}
                  onMouseLeave={e => { if (!e.currentTarget) return; e.currentTarget.style.background = value === o.value ? '#f0f9ff' : 'transparent'; }}>
                  <div style={{ fontWeight:500 }}>{o.label}</div>
                  <div style={{ fontSize:'0.75rem', color:'#64748b' }}>{o.value}</div>
                </div>
              )) : (
                <div style={{ padding:'12px', textAlign:'center', color:'#94a3b8', fontSize:'0.875rem' }}>No results found</div>
              )}
            </div>
          </div>
        )}
      </div>
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
